function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "red",
  d: "M0 0h640v160H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#00f",
  d: "M0 160h640v160H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "orange",
  d: "M0 320h640v160H0z"
});

var SvgAm = function SvgAm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 640 480"
  }, props), _ref, _ref2, _ref3);
};

export default SvgAm;